import { Observable } from 'rxjs';
import { ApiBaseService } from './api.base.service';
import { AbstractModel } from '../../models';
import { HttpHeaders, HttpResponse } from '@angular/common/http';

export abstract class ApiDataService<T extends AbstractModel> extends ApiBaseService {
    public getItem = (
        id: number,
        params?: { [param: string]: string | string[] },
    ): Observable<T> => {
        return this.get<T>(String(id || ''), params);
    };

    public getItemByParams = (params?: {
        [param: string]: string | string[] | number | boolean;
    }): Observable<T> => {
        return this.get<T>('', params);
    };

    public createItem = (data: T): Observable<T> => {
        return this.post<T>('', JSON.stringify(data));
    };

    public createItemWithQueryParams = (data: T, queryParams = ''): Observable<T> => {
        return this.post<T>(queryParams, JSON.stringify(data));
    };

    public updateItem = (id: number, data: T): Observable<T> => {
        return this.put<T>(String(id || ''), JSON.stringify(data));
    };

    public updateItemWithPartUrl = (id: number, partUrl: string, data: T): Observable<T> => {
        return this.put<T>(String(id || '') + `/${partUrl}`, JSON.stringify(data));
    };

    public deleteItem = (id: number): Observable<void> => {
        return this.delete<void>(String(id || ''));
    };

    public patchItem = (id: number, data: any): Observable<T> => {
        return this.patch<T>(String(id || ''), JSON.stringify(data || ''));
    };

    public export = (params?: { [param: string]: string | string[] | number }): Observable<T> => {
        return this.exportFile('', params);
    };

    public downloadFile(data: HttpResponse<Blob>): void {
        let fileName = decodeURIComponent(this.getFilename(data.headers));

        const contentType = data.headers.get('content-type') || '';

        const extension = this.getExtensionFromContentType(contentType);
        fileName += extension;

        const blob = data.body;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(url);
    }

    private getExtensionFromContentType(contentType: string): string {
        switch (contentType) {
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                return '.xlsx';
            case 'application/vnd.ms-excel':
                return '.xlsx';
            case 'application/pdf':
                return '.pdf';
            default:
                return '';
        }
    }

    public getFilename(headers: HttpHeaders): string {
        const contentDisposition = headers.get('content-disposition');
        let filename = '';
        if (contentDisposition) {
            const part = contentDisposition
                .split(';')
                .find(item => item && item.trim().startsWith('filename'));
            if (part) {
                filename = part
                    .split('=')[1]
                    .trim()
                    .replace(/^"(.+?)"$/, '$1');
            }
        }

        return filename;
    }
}
